import { useMediaQuery, useTheme } from '@material-ui/core'
import { useSectionId } from '@v4/components/common/SectionItem'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import useStyles from './FAQ3.styled'

export const useFAQ3 = props => {
	const { metaData } = props
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	const sectionId = useSectionId()
	const items = PageBuilderSelector.useRepeatableGroupKeys({
		sectionId,
		group: 'items',
	})

	const classes = useStyles(props)

	return [
		{
			classes,
			isMobile,
			direction: isMobile ? null : metaData.direction?.contentReverseDirection(),
			items,
			contentWidth: metaData.contentWidth?.metaValue,
			mobileAlignment: metaData.mobileAlignment,
			mobileButtonWidth: metaData.mobileButtonWidth,

			mataText: metaData.text,
			textMetaKey: 'text',

			metaButtonText: metaData.buttonText,
			buttonTextMetaKey: 'buttonText',
			metaButtonAction: metaData.buttonAction,
			buttonButtonLink: metaData.buttonLink,
		},
	]
}
